import { AssetSummaryItem } from '../types'

const periodMap = {
  all: 'Full',
  '6m': 'SixMonth',
  '1y': 'OneYear',
  '3y': 'ThreeYear',
  '5y': 'FiveYear',
  '10y': 'TenYear'
}

type AssetWeight = {
  asset: {
    assetId: string
    name: string
  }
  weight: number
}

type PerformanceInPeriod = {
  annualisedVolatility: number
  period: string
  totalReturn: number
}

type AssetPerformance = {
  assetId: string
  performance: PerformanceInPeriod[]
}

function getPerformanceForPeriod(perf: AssetPerformance[], period: string, assetId: string) {
  const result = perf.find(x => x.assetId === assetId)?.performance?.find(x => x.period === period)
  return result
}

export function extractAssetPerformance(
  assetTargetWeights: AssetWeight[],
  assetPerformance: AssetPerformance[]
): Record<string, AssetSummaryItem[]> {
  const output: Record<string, AssetSummaryItem[]> = {}
  for (const period of Object.keys(periodMap)) {
    const entries = assetTargetWeights.map(tw => {
      const perf = getPerformanceForPeriod(assetPerformance, periodMap[period], tw.asset?.assetId)

      return {
        id: tw.asset.assetId,
        name: tw.asset.name,
        weight: tw.weight,
        return: perf.totalReturn,
        volatility: perf.annualisedVolatility
      }
    })

    output[period] = entries
  }

  return output
}
